import React, { memo } from 'react'
import { showModal } from '../../../../store/actions/modalActions'
import { ModalTypes } from '../../../../types/modals'
import { RiskyParameterDisclaimer } from './RiskyParameterDisclaimer'
import { useAppDispatch } from '../../../../hooks/useAppDispatch'
import unlockBtn from '../../../../assets/icons/unlock.svg'
import styles from './index.module.scss'
import { withTooltip } from '../../../../utils/withTooltip'

interface RiskyParamUnlockBtnProps {
    onUnlockConfirm: () => void
    changeWarning: string | undefined
}

export const RiskyParamUnlockBtn = memo(
    function RiskyParamUnlockBtn(props: RiskyParamUnlockBtnProps) {
        const { changeWarning, onUnlockConfirm } = props
        const dispatch = useAppDispatch()

        const handleChangeRiskyParam = () => {
            dispatch(
                showModal(ModalTypes.MAIN_MODAL, {
                    body: (
                        <RiskyParameterDisclaimer
                            changeWarning={changeWarning ?? ''}
                        />
                    ),
                    onSubmit: onUnlockConfirm,
                })
            )
        }

        const btn = (
            <button
                className={`ms-2 d-inline-block btn-clean ${styles.unlockBtn}`}
                onClick={handleChangeRiskyParam}
            >
                <img
                    src={unlockBtn}
                    alt="Unlock risky param"
                />
            </button>
        )

        return withTooltip(btn, 'Unlock field', 'unlockRiskyParam')
    }
)